// ============================================================
// COOKIELOZE BEZOEKERSSTATISTIEKEN
// ============================================================
// Stuurt pageview-, engagement-, klik- en form-events naar de dashboard-API.
// Bewust GEEN cookies en GEEN localStorage → geen consent-/cookie-banner nodig.
// Het IP wordt server-side geanonimiseerd; uniek-bezoeker-telling gebeurt daar
// met een dagelijks roterende hash (zie docs/dashboard_changes_needed.md §5).
//
// Alles is feature-detected en in try/catch verpakt: meten mag de site nooit breken.

const ENDPOINT = (() => {
  const h = location.hostname
  if (h === "localhost" || h === "127.0.0.1") return "http://localhost:3000/api/v1/events"
  if (h === "hovetechniek.nl" || h === "www.hovetechniek.nl") return "https://dashboard.hovetechniek.nl/api/v1/events"
  return null // staging/preview: bewust niet meten, vervuilt de cijfers niet
})()

if (ENDPOINT) initAnalytics()

function initAnalytics() {
  try {
    const params = new URLSearchParams(location.search)

    // In-memory id (geen opslag) om de events van één paginabezoek te koppelen.
    const viewId =
      (window.crypto && crypto.randomUUID && crypto.randomUUID()) ||
      Date.now().toString(36) + Math.random().toString(16).slice(2)

    const startTime = performance.now()
    let maxScroll = 0
    let lcpMs = 0

    function send(payload) {
      try {
        const body = JSON.stringify(payload)
        // text/plain = CORS-safe → geen preflight nodig voor de cross-domain POST.
        const blob = new Blob([body], { type: "text/plain;charset=UTF-8" })
        if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, blob)) return
        fetch(ENDPOINT, {
          method: "POST",
          body,
          headers: { "Content-Type": "text/plain" },
          keepalive: true,
          mode: "no-cors",
        }).catch(() => {})
      } catch (_) {}
    }

    const base = () => ({ v: viewId, path: location.pathname })

    // ---- 1. Pageview ----
    const utm = {}
    ;["source", "medium", "campaign", "term", "content"].forEach((k) => {
      const val = params.get("utm_" + k)
      if (val) utm[k] = val
    })

    send({
      event: "pageview",
      ...base(),
      query: location.search || null,
      title: document.title,
      referrer: document.referrer || null,
      utm: Object.keys(utm).length ? utm : null,
      partner: params.get("partner") || null,
      product: params.get("product") || null,
      screen_w: screen.width,
      screen_h: screen.height,
      viewport_w: window.innerWidth,
      viewport_h: window.innerHeight,
      dpr: window.devicePixelRatio || 1,
      language: navigator.language || null,
      timezone: (Intl.DateTimeFormat().resolvedOptions().timeZone) || null,
      connection: (navigator.connection && navigator.connection.effectiveType) || null,
      ts: Date.now(),
    })

    // ---- 2. Scroll-diepte ----
    function trackScroll() {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight
      const pct = scrollable > 0 ? Math.round((window.scrollY / scrollable) * 100) : 100
      if (pct > maxScroll) maxScroll = Math.min(100, pct)
    }
    window.addEventListener("scroll", trackScroll, { passive: true })
    trackScroll()

    // ---- 3. Largest Contentful Paint (laadbeleving) ----
    try {
      if (window.PerformanceObserver) {
        const po = new PerformanceObserver((list) => {
          for (const entry of list.getEntries()) lcpMs = Math.round(entry.startTime)
        })
        po.observe({ type: "largest-contentful-paint", buffered: true })
      }
    } catch (_) {}

    // ---- 4. Klikken op belangrijke links (conversies) ----
    document.addEventListener(
      "click",
      (e) => {
        const a = e.target.closest && e.target.closest("a")
        if (!a) return
        const href = a.getAttribute("href") || ""
        let kind = null
        if (href.startsWith("tel:")) kind = "tel"
        else if (href.startsWith("mailto:")) kind = "mailto"
        else if (/^https?:\/\//i.test(href) && !href.includes(location.hostname)) kind = "outbound"
        if (kind) {
          send({
            event: "click",
            ...base(),
            kind,
            href,
            text: (a.textContent || "").trim().slice(0, 80) || null,
            ts: Date.now(),
          })
        }
      },
      { capture: true }
    )

    // ---- 5. Formulier-verzending (conversie-intentie) ----
    document.addEventListener(
      "submit",
      (e) => {
        const form = e.target
        if (form && form.classList && form.classList.contains("hove-form")) {
          const typeInput = form.querySelector('input[name="type"]')
          send({
            event: "form_submit",
            ...base(),
            form_type: typeInput ? typeInput.value : null,
            ts: Date.now(),
          })
        }
      },
      { capture: true }
    )

    // ---- 6. Engagement bij verlaten van de pagina ----
    let engagementSent = false
    function sendEngagement() {
      if (engagementSent) return
      engagementSent = true
      const perf = {}
      try {
        const nav = performance.getEntriesByType("navigation")[0]
        if (nav) {
          perf.ttfb_ms = Math.round(nav.responseStart)
          perf.dom_ms = Math.round(nav.domContentLoadedEventEnd)
          perf.load_ms = Math.round(nav.loadEventEnd || nav.duration)
        }
      } catch (_) {}
      send({
        event: "engagement",
        ...base(),
        duration_ms: Math.round(performance.now() - startTime),
        max_scroll_pct: maxScroll,
        lcp_ms: lcpMs || null,
        ...perf,
        ts: Date.now(),
      })
    }
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") sendEngagement()
    })
    window.addEventListener("pagehide", sendEngagement)
  } catch (_) {}
}
